/**
 * OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPage
 *
 * Page component for OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPage
 * Path: /docs/core-concepts/pages
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPagesENDocScreenView as __OrbDocCoreConceptsPagesENDocScreenView } from '@/components/traits/OrbDocCoreConceptsPagesENDocScreenView';
import { OrbDocCoreConceptsPagesENDocAnalyticsView as __OrbDocCoreConceptsPagesENDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPagesENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPage(_props: OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Pages","description":"Routes, and how the traits on a route share the screen.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/pages"},{"locale":"ar","path":"/ar/docs/core-concepts/pages"},{"locale":"sl","path":"/sl/docs/core-concepts/pages"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPagesENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPagesENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPagesENOrbDocCoreConceptsPagesENPage;
